// @ts-nocheck
import { axiosInstance } from "@/lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from '@/hooks/use-toast';
import type { Offer } from '@/types/Offer';


const offerPatch = async (velId, offerId, body: Partial<Offer>) => {
  const { data } = await axiosInstance.patch(
    `/api/abo/vel/${velId}/offer/${offerId}`
    , body
  );
  return data;
};

export const useOfferPatch = ({velId, offerId}) => {
  const {toast} = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Partial<Offer>) =>
      offerPatch(velId, offerId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["vel", velId, 'offers'],
      });
      queryClient.refetchQueries(["vel", velId, 'offers']);
      toast({
        variant: "default",
        title: "La bannière a été modifiée",
      });
    },
    onError: () => {
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};

